"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.concatStyles = void 0;
var clsx_1 = __importDefault(require("clsx"));
var concatStyles = function () {
    var styles = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        styles[_i] = arguments[_i];
    }
    return clsx_1.default.apply(void 0, styles);
};
exports.concatStyles = concatStyles;
